import { render } from "./ManagerData.vue?vue&type=template&id=f030a8c4&scoped=true&ts=true"
import script from "./ManagerData.vue?vue&type=script&lang=ts"
export * from "./ManagerData.vue?vue&type=script&lang=ts"

import "./ManagerData.vue?vue&type=style&index=0&id=f030a8c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f030a8c4"]])

export default __exports__